import { apiClient } from './client';

export interface AffiliateApplicationData {
  fullName: string;
  country: string;
  companyName?: string;
  website?: string;
  socialMedia?: string;
  howWillPromote?: string;
  payoutMethod: 'bank' | 'paypal';
  iban?: string;
  paypalEmail?: string;
  taxId?: string;
}

export interface ApplicationStatus {
  hasApplication: boolean;
  status: 'pending' | 'approved' | 'rejected' | null;
  rejectionReason?: string;
  createdAt?: string;
  reviewedAt?: string;
}

export interface ReferralConversion {
  userId: string;
  subscriptionId: string;
  convertedAt: string;
  revenue: number;
  commissionEarned: number;
}

export interface ReferralStats {
  code: string | null;
  conversionsCount: number;
  totalEarnings: number;
  pendingEarnings: number;
  paidEarnings: number;
  conversions?: ReferralConversion[];
}

export interface UpdatePayoutInfoData {
  payoutFullName?: string;
  payoutCountry?: string;
  payoutMethod?: 'bank' | 'paypal';
  payoutIban?: string;
  payoutPaypalEmail?: string;
  payoutTaxId?: string;
}

export const referralsApi = {
  validateCode: async (code: string) => {
    const response = await apiClient.get<{ valid: boolean }>(`/referrals/validate/${code}`);
    return response.data;
  },

  setReferralCode: async (code: string) => {
    const response = await apiClient.post<{ success: boolean; code: string }>('/referrals/set-referral-code', { code });
    return response.data;
  },

  getMyReferral: async () => {
    const response = await apiClient.get('/referrals/me');
    return response.data;
  },

  getMyStats: async () => {
    const response = await apiClient.get<ReferralStats>('/referrals/me/stats');
    return response.data;
  },

  getApplicationStatus: async () => {
    const response = await apiClient.get<ApplicationStatus>('/referrals/application/status');
    return response.data;
  },

  applyForAffiliate: async (data: AffiliateApplicationData) => {
    const response = await apiClient.post('/referrals/apply', data);
    return response.data;
  },

  updatePayoutInfo: async (data: UpdatePayoutInfoData) => {
    const response = await apiClient.patch<{ success: boolean }>('/referrals/payout-info', data);
    return response.data;
  },
};
